import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-report-footers',
  templateUrl: './report-footers.component.html',
  styleUrls: ['./report-footers.component.scss']
})
export class ReportFootersComponent implements OnInit {

  RepFooter: FormGroup;
  dialogRef: MatDialogRef<any>;
  examList: any;
  filteredListExam: any;
  submitButton = true;
  New = true;
  editButton = false;
  deleteButton = false;
  submitpayload: any;
  filteredListReport: any;
  reportList: any;
  rpCode = 0;
  EMID = 0;
  serialNo = 1;
  APIService: any;
  reportHeadList: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    public fb: FormBuilder) {this.APIService = environment.serviceUrl;  }

  ngOnInit(): void {
    this.submitButton = true;
    this.New = true;
    this.editButton = false;
    this.deleteButton = false;
    this.RepFooter = this.fb.group({
      RhRptCode: new FormControl(),
      RhEmId: new FormControl(),
      Seq: new FormControl(),
      RhHdrFtr: new FormControl(),
      RhHeader: new FormControl(),
      RhSrNo: new FormControl(this.serialNo),
     } );

     this.repDetails();
     this.fetchExam();
  }

  repDetails() {
    const payload = {};
    payload['RptTime'] = '';
    payload['RptCode'] = 0;
    this.umsService.reportDetailFt(payload).subscribe(res => {
      if (res.status) {
        this.reportList = res.data;
        this.filteredListReport = this.reportList.slice();
      }
    });
  }

  getCode(RptCode){
    this.rpCode = RptCode;
  }

  fetchExam() {
    const payload = {};
    payload['EmCoCode'] = "";
    payload['EmId'] = 0;
    this.umsService.getExam(payload).subscribe(
      (res) => {
        if (res.status) {
          this.examList = res.data;
          this.filteredListExam = this.examList.slice();
        } else {
        }
      }
    );
  }

  getEmId(EmId){
    this.EMID = EmId;
  }

  list(){
    const payload = {};
    payload['RhRptCode'] = this.rpCode;
    payload['EmId'] = this.EMID;
    payload['ShId'] = 0;
    if(this.EMID == 0){
      payload['Flag'] = 'C';
    }
    else{
      payload['Flag'] = 'E';
    }
    this.umsService.reportHead(payload).subscribe(
      (res) => {
        if (res.status) {
          this.reportHeadList = res.data;
          if(res.length > 0){
            this.RepFooter['RhSrNo'] = this.serialNo + 1
          }
        } else {
        }
      }
    );
  }
  
  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }


  prepopulation(data){
    this.editButton = false;
    this.submitButton = true;
    this.deleteButton = false;
    this.New = false;
    this.RepFooter = this.fb.group({
      RhRptCode: new FormControl(data.RhRptCode),
      RhEmId: new FormControl(data.RhEmId),
      Seq: new FormControl(data.Seq),
      RhHdrFtr: new FormControl(data.RhHdrFtr),
      RhHeader: new FormControl(data.RhHeader),
      RhSrNo: new FormControl(data.RhSrNo),
     } );
  }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.New = true
      this.deleteButton = false;
       this.RepFooter.reset();
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
      this.New = false
        this.ngOnInit();
    }
  }

  submit(){
    if (this.RepFooter.invalid) {
      this.RepFooter.get('RhHeader').markAsTouched();
      this.RepFooter.get('RhRptCode').markAsTouched();
      return;
    } else {
      this.submitRepFooter();
    }
  }
  

  submitRepFooter() {
    this.spinner.show();
    this.submitpayload = this.RepFooter.value;
    this.umsService.addRpFt(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  NewBtn(){
    this.RepFooter.reset();
  }

}
